<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'casas', params:{idBusiness: idBusiness}}">{{$t("casas")}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t("casa")}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{nombreNegocio}}</h2>
                            <hr>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="nameCasa"><strong>{{$t("nombreCasa")}} <span style="color: red">*</span></strong></label>
                                <input type="text" class="form-control"
                                       :class="{'is-valid': casa.name.length >0 && casa.name.length <= maxNameCasa,
                                       'is-invalid': casa.name.length > maxNameCasa}"
                                       id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="casa.name"
                                       ref="name">
                                <input type="hidden" v-model="casa.xname">
                                <small class="form-text text-muted">{{casa.name.length}}/50</small>
                            </div>
                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cifnifCasa"><strong>{{$t("cifNif")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cifnifCasa" v-bind:placeholder="$t('introduzcaCifNif')"
                                       v-model="casa.cifnif">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="addressCasa"><strong>{{$t("direccion")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="addressCasa" v-bind:placeholder="$t('introduzcaDireccion')"
                                       v-model="casa.address">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="provinceCasa"><strong>{{$t("provincia")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="provinceCasa" v-bind:placeholder="$t('introduzcaProvincia')"
                                       v-model="casa.province">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cityCasa"><strong>{{$t("ciudad")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cityCasa" v-bind:placeholder="$t('introduzcaCiudad')" v-model="casa.city">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cpCasa"><strong>{{$t("codigoPostal")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cpCasa" v-bind:placeholder="$t('introduzcaCodigoPostal')" v-model="casa.cp">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="phoneCasa"><strong>{{$t("telefono")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="phoneCasa" v-bind:placeholder="$t('introduzcaTelefono')"
                                       v-model="casa.phone">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="emailCasa"><strong>{{$t("correoElectronico")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="emailCasa" v-bind:placeholder="$t('introduzcaCorreo')" v-model="casa.email">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <!-- baja -->
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="casa.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" v-once-click.once="saveCasa" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'casas', params:{idBusiness: idBusiness, 'pag' : pag}}">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                                </button>
                            </router-link>
                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{$t("replicar")}}
                            </el-checkbox>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="modalReply" :adaptive=true :scrollable=true height="auto"  :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("replicarCasa")}}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{$t("seleccionarTodos")}}</label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                                     class="checkbox-element" style="width: 100%">
                            {{business.establishmentName}}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="closeModal()"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="replyCasa"><i class="fa fa-check-circle"></i>
                        {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import swal from 'sweetalert2'
    import {Checkbox, Switch} from 'element-ui';
    import {Loading} from 'element-ui';

    export default {
        props: ['idBusiness', 'idCasa', 'pag', 'desdeSubproducto', 'idSubproducto'],
        created() {
            this.action = this.idCasa ? this.$i18n.t("editar") : this.$i18n.t("nueva");

            this.loadingGeneral = Loading.service({text: this.$t('cargando')});

            this.identificacionNegocio();
            if (this.idCasa) {
                this.getCasa();
            }
            else{
                this.loadingGeneral.close();
            }
        },
        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch
        },
        mounted() {
            this.$refs.name.focus();
        },
        data() {
            return {

                loadingGeneral: null,
                casa: {
                    name: "",
                    xname: "",
                    cifnif: "",
                    address: "",
                    province: "",
                    city: "",
                    cp: "",
                    phone: "",
                    email: "",
                    baja: false
                },
                checkSelectAll: false,
                listBusinesses: [],
                checkReply: false,
                maxNameCasa: 50,
                action: "",
                inProgress: false,
                nombreNegocio: ""
            }
        },
        methods: {
            identificacionNegocio() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreNegocio = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            checkCampos() {
                if (this.casa.name.length > this.maxNameCasa) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameCasa + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else if (this.casa.name === null || this.casa.name.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    return true;
                }
            },
            getCasa() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idCasa: this.idCasa,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'casas/getCasaById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.casa = response.data.result;
                            vm.casa.xname = response.data.result.name;

                            vm.loadingGeneral.close();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            saveCasa() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params:{
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        casa: this.casa,
                        jwt: this.$store.getters.jwt
                    };

                    console.log(params);

                    let vm = this;
                    let controller = this.idCasa ? "editCasaById" : "newCasaByBusiness";
                    this.axios.post(this.$store.getters.apiUrl + 'casas/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.idCasa ? vm.$t('actualizada') : vm.$t('creada');
                                vm.$notify({
                                    message: vm.$t('casa') + ' ' + notify + ' ' + vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                if (vm.checkReply) {

                                    if (!vm.idCasa) {
                                        vm.casa.xname = vm.casa.name;
                                    }

                                    vm.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                                        .then(function (response) {
                                            if (response.data.response) {
                                                vm.listBusinesses = response.data.result;
                                                vm.$modal.show('modalReply');
                                            } else {
                                                swal({
                                                    title: vm.$t('atencion'),
                                                    text: response.data.result,
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    type: 'error'
                                                });
                                            }

                                        });

                                } else {

                                    if (!vm.desdeSubproducto) {
                                        vm.$router.push({
                                            name: 'casas',
                                            params: {idBusiness: vm.idBusiness, 'pag': vm.pag}
                                        })
                                    }
                                    else {
                                        vm.$router.push({
                                            name: 'subproducto',
                                            params: {
                                                idBusiness: vm.idBusiness,
                                                idSubproducto: vm.idSubproducto,
                                                ultimaCasa: response.data.result,
                                                'pag': vm.pag
                                            }
                                        })

                                    }
                                }

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
            },
            replyCasa() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;

                let xbusinesses = new Array();
                this.listBusinesses.forEach(function (business) {
                    if (business.checked && business.id!==vm.idBusiness) {
                        xbusinesses.push(business);
                    }
                });

                var params = {
                    listBusinesses: xbusinesses,
                    casa: this.casa,
                    jwt: this.$store.getters.jwt
                };


                this.axios.post(this.$store.getters.apiUrl + 'casas/replyCasa', params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            vm.closeModal();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
            },
            closeModal() {
                this.$modal.hide('modalReply');
                this.$router.push({name: 'casas', params: {idBusiness: this.idBusiness, 'pag': this.pag}})
            },
            selectAll() {
                if (this.checkSelectAll) {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = false;
                    });
                } else {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = true;
                    });
                }
            }
        }

    }
</script>

<style scoped>
    .card {
        padding: 20px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Widgets/Casas/CasaForm.vue